<template>
  <div>
    <header class="form-title">
      <Row>
        <Col span="20">        
          <Form inline :label-width="60">
            <FormItem prop="dynamic" label="客户">
              <el-popover
                placement="bottom"
                width="240"
                ref="customerPopover"
                @show="dynamicCustomerShow"
                @hide="dynamicCustomerHide"
                popper-class="dynamic-selector-popover"
                trigger="manual">
                
                <ul class="customer-list">
                  <li v-for="customer in filterCustomerList" :key="customer.id" :v-if="customer.isdel != 0" @click="selectCustomer(customer)">
                    <span v-if="customer.customerType == 1 && !customer.disabled" style="color: #ff5e5e">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                    <span v-if="customer.customerType == 0 && !customer.disabled" style="color: #2d8cf0">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                    <span v-if="customer.customerType == null && !customer.disabled">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                  </li>

                  <li v-if="isLoadMoreBtnShow()">
                      <div class="load-mote-customer-content" @click="loadMoreCurstomer">
                        <span v-if="isCallCustomerApi" class="el-icon-loading"></span>
                        <span v-else>加载更多</span>
                      </div>
                  </li>

                  <li v-if="isNoDataShow()">
                      <div class="no-data-msg">空空如也 没有数据</div>
                  </li>
                </ul>

                <div slot="reference" @click="showDynamicCustomerList" class="dynamic-customer">
                  <el-Input size="small" class="formSelect-input" v-if="isDynamicSearchShow" v-model="customerSearchTxt" />
                  <el-Input size="small" class="formSelect-input" v-else :value="selectedUserName" />
                  <span :class="`el-icon-arrow-up dynamic-custoer-search-arrow ${isDynamicListShow ? 'up' : 'down'}`"></span>
                </div>
                
              </el-popover>
            </FormItem>
          
            <FormItem prop="password" label="门店">
              <el-Input size="small" v-model="formSelect.store" class="formSelect-input" disabled />
            </FormItem>
            <FormItem prop="password" label="业务员">
              <el-select
                size="small"
                :disabled="ruleflag"
                filterable
                v-model="formSelect.salesperson"
                class="formSelect-input"
                ref="salespersonKey"
              >
                <el-option :value="formSelect.adminuserid">{{adminuser}}</el-option>
                <el-option :value="k.id" :label="k.name" v-for="(k,v) in salesman" :key="v"></el-option>
              </el-select>
            </FormItem>
          </Form>
        </Col>
        <Col span="4" align="right">
          <Button
            style="position: relative;top: -10px;margin-right: 5px"
            type="primary"
            @click="commodityModal=true"
          >
            <Icon type="md-add" />
          </Button>
          <Button
            style="position: relative;top: -10px;"
            type="primary"
            @click="savedraft"
          >存草稿</Button>
        </Col>
      </Row>
    </header>
    <div>
      <Alert v-if="afterSelection.length==0" align="center">请添加商品</Alert>
      <Collapse v-model="opensTable" v-if="afterSelection.length!=0">
        <Panel :name="index+''" v-for="(item,index) in afterSelection" :key="index">
          <span>{{ item.name }} ({{item.goodscode}})&nbsp;&nbsp;&nbsp;&nbsp;件数{{item.nums}}</span>
          <table slot="content" class="ive-table">
            <thead>
              <th>商品图</th>
              <th>规格</th>
              <th>颜色</th>
              <th>
                销售价
                <span class="finger" @click="editallprice(item,ischooseing,1)">
                  <Icon type="md-create" />
                </span>
              </th>
              <th>折扣率</th>
              <th>折后价</th>
              <th>数量</th>
              <th>小计</th>
              <th>操作</th>
            </thead>
            <tbody>
              <tr align="center" v-for="(k,v) in item.goodsItem" :key="v">
                <td :rowspan="item.goodsItem.length" v-if="v==0" width="140">
                  <Fy-Img
                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                    :Width="100"
                    :Height="100"
                  ></Fy-Img>
                </td>
                <td>{{k.size}}--{{isShowyouhui}}</td>
                <td>{{k.color}}</td>
                <td class="finger" v-if="ischooseing">
                  <div>
                    <InputNumber v-if="ischooseing&&!changelprice.includes('128')"
                      :disabled="true"
                      v-model="k.lprice"
                      size="small"
                      :max="999999"
                      :min="0"
                      @on-change="editprice(item,v,k.lprice,ischooseing,1)"
                    ></InputNumber>
                    <InputNumber v-else
                    
                      v-model="k.lprice"
                      size="small"
                      :max="999999"
                      :min="0"
                      @on-change="editprice(item,v,k.lprice,ischooseing,1)"
                    ></InputNumber>
                    <span v-if="k.lOldIcon" style="font-size: 0.5rem;width: auto;color: #ff7b61;right: 0.2rem;top: 0.3rem;"
                    >历</span>
                    <span v-if="k.buyQuantity && k.buyQuantity != 0" style="margin-left: 0.3rem;font-size: 0.7rem;width: auto;color: #ff7b61;top: 0.05rem;">{{ k.buyQuantity + " " + k.saleItemBuyTime }}</span>

                  </div>
                </td>
                <td class="finger" v-else>
                  <div>
                  <InputNumber
                      v-model="k.pprice"
                      size="small"
                      :max="999999"
                      :min="0"
                      @on-change="editprice(item,v,k.pprice,ischooseing,1)"
                    ></InputNumber>
                    <span v-if="k.pOldIcon" style="font-size: 0.7rem;width: auto;color: #ff7b61;right: 0.2rem;top: 0.3rem;"
                    >历</span>                   
                    <span v-if="k.buyQuantity && k.buyQuantity != 0" style="margin-left: 0.3rem;font-size: 0.7rem;color: #ff7b61;top: 0.05rem;">{{ k.buyQuantity + " " + k.saleItemBuyTime }}</span>
                  </div>
                  
                </td>
                <td class="finger" @click="editprice(item,v,k.zkv,ischooseing,2)">{{k.zkv}}%</td>
                <td v-if="ischooseing">{{(k.zkv/100 * k.lprice).toFixed(2)}}</td>
                <td v-else>{{(k.zkv/100 * k.pprice).toFixed(2)}}</td>
                <td>{{k.nums}}</td>
                <td v-if="ischooseing">{{(k.zkv/100 * k.lprice*k.nums).toFixed(2)}}</td>
                <td v-else>{{(k.zkv/100 * k.pprice*k.nums).toFixed(2)}}</td>
                <td :rowspan="item.goodsItem.length" v-if="v==0" width="80">
                  <ButtonGroup shape="circle">
                    <Button type="primary" icon="md-create" title="编辑" @click="editSendData(item)"></Button>
                    <Button
                      type="warning"
                      icon="md-trash"
                      title="删除"
                      @click="delSendData(item,index)"
                    ></Button>
                  </ButtonGroup>
                </td>
              </tr>
            </tbody>
          </table>
        </Panel>
      </Collapse>
      <Row style="width:100%;margin-top: 1rem">
        <Col span="4">
          <span class="msgOne">
            商品金额：
            <strong>{{formSelect.showMoneys.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="5">
          <span class="msgAll">
            客户尚欠款：
            <strong>{{formSelect.customerArrears.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="3">
          <span class="msgAll">
            本单欠款：
            <strong>{{formSelect.nomoneys.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="4" v-if="isShowyouhui&discountListStatus!=3">
          <span class="msgAll">
            客户积分：
            <strong>{{formSelect.customerIntegral}}</strong>
          </span>
        </Col>
        <Col span="3" v-if="isShowyouhui&discountListStatus!=3">
          <span class="msgAll">
            本单积分：
            <strong>{{formSelect.thisBillIntegral}}</strong>
          </span>
        </Col>
        <Col span="3">
          <span class="msgAll">
            总件数：
            <strong>{{allnumber}}</strong>
          </span>
        </Col>        
      </Row>      
      <Row style="margin-top: 1rem">
        <Col span="20">
          <Form inline :label-width="100">
            <FormItem label="商品抹零">
              <el-Input
                size="small"
                :min="0"
                :maxlength="10"
                @input="checkNumber"
                class="formSelect-input"
                v-model="formSelect.removeDecimal"
                ref="removeDecimalKey"
                name="removeDecimalName"
              ></el-Input>                  
              <Button style="margin-left: 5px" @click="moling">抹零</Button>
            </FormItem>
            <FormItem label="选择优惠" v-if="isShowyouhui">
              <el-Select 
                filterable
                size="small" 
                v-model="formSelect.discount" 
                class="formSelect-input" 
                ref="discountKey"
              >
                <el-Option
                  :value="k.id"
                  v-for="(k,v) in discountList"
                  :key="v"
                  :disabled="discountListStatus==k.state|| (discountListStatus==3&&k.state==1) ||(discountListStatus==3&&k.state==2)"
                  :label="k.label"
                ></el-Option>
              </el-Select>
            </FormItem>

            <FormItem label="会员卡余额" v-if="formSelect.discount==4 && isShowyouhui">
              <strong style="color: #ff5e5e">{{pmoneyTpmoney.toFixed(2)}}</strong>
            </FormItem>
            <FormItem label="优惠方式" v-if="formSelect.discount==3 && isShowyouhui">
              折扣率:
              <strong style="color: #ff5e5e">{{zhekoulv}}%</strong>
            </FormItem>
            <!--会员卡-->
            <FormItem label="结算账户:" v-if="formSelect.discount==4 && isShowyouhui">
              <strong style="color: #ff5e5e">会员卡</strong>
            </FormItem>
            <FormItem label="会员卡扣除:" v-if="formSelect.discount==4 && isShowyouhui">
              <strong style="color: #ff5e5e">￥{{formSelect.noMoney.toFixed(2)}}</strong>
            </FormItem>
            <FormItem label="实收金额" v-if="formSelect.discount!=4">
              <el-Input
                size="small"
                :min="0"
                :maxlength="10"
                @input="checkNumber"
                class="formSelect-input"
                v-model="formSelect.realMoney"
                ref="realMoneyKey"
                name="realMoneyName"
              ></el-Input>
              <Button style="margin-left: 5px" @click="normerbtn">{{normertext}}</Button>
            </FormItem>

            <FormItem label="优惠金额" v-if="formSelect.discount==2 && isShowyouhui ">
              每消耗{{jfData.employ}}积分抵扣￥{{jfData.deposit}}，共抵扣
              <strong
                style="color: #ff5e5e"
              >{{formSelect.alljfNum.toFixed(2)}} 元</strong>
            </FormItem>  

            <FormItem label="结算账户" v-if="formSelect.discount!=4 ">
              <el-Select 
                filterable
                size="small" 
                v-model="formSelect.bank" 
                class="formSelect-input" 
                ref="bankKey"
              >
                <el-Option
                  :v-if="k.type!=6"
                  v-for="(k,v) in bankList"
                  :key="v"
                  :value="k.id" 
                  :label="k.bankname"
                ></el-Option>
              </el-Select>
            </FormItem>            
          </Form>
        </Col>
        <Col span="4" align="center">
          <!-- <span>合计：{{Lastmoney.toFixed(2)}}</span> -->
          <span>
            实收:{{formSelect.merge.toFixed(2)}}
            <strong v-if="allRemoveDecimal>0" style="color: #ff5e5e">
              抹零({{allRemoveDecimal}})
            </strong>
          </span>
          <Button
            type="primary"
            :loading="loadingOpeningOrder"
            @click="openingOrder()"
            style="margin-left: 15px"
          >
            <span v-if="!loadingOpeningOrder">出售</span>
            <span v-else>提交中</span>
          </Button>
        </Col>
        <Col span="24" v-if="formSelect.discount!=4">
          <Form inline :label-width="100">
            <FormItem label="组合收款">
                <mt-switch v-model="isOpenCb"></mt-switch>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" v-if="formSelect.discount!=4 && isOpenCb" >
          <Form inline :label-width="100">
            <FormItem label="结算账户">
              <el-Select 
                filterable
                size="small" 
                v-model="formSelect.bank2" 
                class="formSelect-input" 
                ref="bank2Key"
              >
                <el-Option
                  :value="k.id"
                  v-for="(k,v) in bankList"
                  :v-if="k.type!=6 && formSelect.bank!=k.id"
                  :key="v"
                  :label="k.bankname"
                ></el-Option>
              </el-Select>
              <span style="margin-left:0.2rem;margin-right:3.8rem"></span>
            </FormItem>
            <FormItem label="实收金额">
              <el-Input
                size="small"
                :min="0"
                :maxlength="10"
                class="formSelect-input"
                v-model="formSelect.realMoney2"
                @input="checkNumber"
                ref="realMoney2Key"
                name ="realMoney2Name"
              ></el-Input>              
              <Button style="margin-left: 0.3rem" @click="normerbtns">{{normertexts}}</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="6">
          <Form inline :label-width="100">
            <FormItem label="备注">
              <Input
                v-model="formSelect.remark"
                type="textarea"
                style="width: 500px"
                :maxlength="50"
                placeholder="备注(最多50个字符)"
                ref="remarkKey"
              />
            </FormItem>
          </Form>
        </Col>
        <!-- <Col span="24">
          <Form inline :label-width="100">
            <FormItem label="历史价格开关">
              <mt-switch v-model="isHistoryOpen"></mt-switch>
            </FormItem>
          </Form>
        </Col> -->
      </Row>
      <Row style="margin-top: 0.5rem">      
        <Col span="24">
          <Form inline :label-width="60">
            <FormItem label="快捷键">
              <el-Select size="small" class="formSelect-input" v-model="key">
                <el-Option value="1">[开单页]shift+q选择客户</el-Option>
                <el-Option value="1">[开单页]shift+W打开商品列表</el-Option>
                <el-Option value="1">[开单页]shift+T抹零金额</el-Option>
                <el-Option value="1">[开单页]shift+y结算账户</el-Option>
                <el-Option value="1">[开单页]shift+a实收金额</el-Option>
                <el-Option value="1">[开单页]shift+s未收/全款转换</el-Option>
                <el-Option value="1">[开单页]shift+D组合收款</el-Option>
                <el-Option value="1">[开单页]shift+F结算账户2</el-Option>
                <el-Option value="1">[开单页]shift+G实收金额2</el-Option>
                <el-Option value="1">[开单页]shift+H补款/清零</el-Option>
                <el-Option value="1">[开单页]shift+J备注</el-Option>
                <el-Option value="1">[开单页]shift+Z选择销售员</el-Option>
                <el-Option value="1">[开单页]shift+X历史价格</el-Option>
                <el-Option value="1">[开单页]shift+c存草稿</el-Option>
                <el-Option value="1">[开单页]shift+v选择优惠方式</el-Option>
                <el-Option value="1">[开单页]shift+enter抹零金额确认</el-Option>
                <el-Option value="1">[开单页]shift+enter开销售单</el-Option>
                <el-Option value="1">[开单页]ctrl+Left打开已选的商品向上</el-Option>
                <el-Option value="1">[开单页]ctrl+Right打开已选商品向下</el-Option>
                <el-Option value="1">[商品列表页]shift+E选择商品搜索框</el-Option>
                <el-Option value="1">[商品列表页]shift+enter选择搜索框状态下查询商品</el-Option>
                <el-Option value="1">[商品列表页]shift+1选择商品1</el-Option>
                <el-Option value="1">[商品列表页]shift+2选择商品2</el-Option>
                <el-Option value="1">[商品列表页]shift+3选择商品3</el-Option>
                <el-Option value="1">[商品列表页]shift+4选择商品4</el-Option>
                <el-Option value="1">[商品列表页]shift+5选择商品5</el-Option>
                <el-Option value="1">[商品列表页]shift+6选择商品6</el-Option>
                <el-Option value="1">[商品列表页]shift+7选择商品7</el-Option>
                <el-Option value="1">[商品列表页]shift+8选择商品8</el-Option>
                <el-Option value="1">[商品列表页]shift+Left商品列表选择上一页</el-Option>
                <el-Option value="1">[商品列表页]shift+Right商品列表选择下一页</el-Option>
                <el-Option value="1">[商品列表页]ctrl+Left选择颜色向左</el-Option>
                <el-Option value="1">[商品列表页]ctrl+Right选择颜色向右</el-Option>
                <el-Option value="1">[商品列表页]shift+r总的添加商品数量tab可以切换</el-Option>
                <el-Option value="1">[商品列表页]enter选完确定</el-Option>
                <el-Option value="1">F1直达销售单页面</el-Option>
                <el-Option value="1">tab切换操作框</el-Option>
                <el-Option value="1">esc关闭商品列表、开单页取消选中操作框</el-Option>
                <el-Option value="1">备注:当选择某个操作框后可能会影响其他操作,用tab键切换下</el-Option>
              </el-Select>
            </FormItem>   
          </Form>
        </Col>        
      </Row>
    </div>
    <!--选择商品-->
    <Modal width="90%" v-model="commodityModal" title="选择添加的商品">
      <Form inline>
        <FormItem prop="password">
          <Input type="text" v-model="searchNeirong" placeholder="请输入商品名、货号" ref="searchNeirongKey" name="searchNeirongName" ></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="getGoodsList(true)">搜索</Button>
        </FormItem>
      </Form>
      <div class="demo-split">
        <Split v-model="split">
          <div slot="left" class="demo-split-pane">
            <table slot="content" class="ive-table">
              <thead>
                <th>选择</th>
                <th width="100">商品图</th>
                <th width="180">名称</th>
                <th>货号</th>
                <th>库存</th>
                <th>零售价</th>
                <th v-if="ispfprice">批发价</th>
                <th>已选</th>
              </thead>
              <tbody>
                <tr
                  align="center"
                  v-for="(item, index) in goodsListL"
                  :key="index"
                  @click="setDataListFn(goodsListL,index)"
                  style="cursor: pointer"
                >
                  <td width="80">
                    <RadioGroup v-model="resultItem.single">
                      <Radio :label="item.id">{{index+1}}</Radio>
                    </RadioGroup>
                  </td>
                  <td>
                    <div class="imgbox">
                      <Fy-Img
                        class="img"
                        :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                        :Width="50"
                        :Height="50"
                      ></Fy-Img>
                      <span v-if="item.tagCode!=null">总</span>
                    </div>
                  </td>
                  <td>{{item.name}}</td>
                  <td>{{item.goodscode}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.lprice}}</td>
                  <td v-if="ispfprice">{{item.pprice}}</td>
                  <td v-if="item.nums>0" style="color: #ff9900">{{item.nums}}</td>
                  <td v-else>{{item.nums}}</td>
                </tr>
              </tbody>
            </table>
            <div class="pageTotal">
              <Page
                :total="page.total"
                show-total
                :current.sync="page.current"
                :page-size="page.rows"
                @on-change="onChange"
              />
              <span class="zongshu">共: {{allnumber}} 件</span>
            </div>
          </div>
          <div slot="right" class="demo-split-pane">
            <div class="commodityMsg">
              <span class="img" v-if="resultItem.goodsimg==''">暂无商品图片</span>
              <Fy-Img class="img" :ImgSrc="resultItem.goodsimg" :Width="80" :Height="80"></Fy-Img>
              <h2>{{resultItem.name}}</h2>
              <h3 v-if="ispfprice">
                批发价:
                <span class="money">￥{{resultItem.lprice}}</span>
              </h3>
              <h3 v-else>
                零售价:
                <span class="money">￥{{resultItem.price}}</span>
              </h3>
              <h3>
                库存:
                <span class="num">{{resultItem.num}}</span>
              </h3>
            </div>
            <div style="max-height: 400px;overflow: auto" class="overflowRightNav">
              <div class="commodityClolr">
                <h3>选择颜色</h3>
                <span
                  class="tag"
                  v-for="(m,n) in resultItem.colors"
                  :key="n"
                  :class="{isSelectClass:selectColorGroup.isCheckable==n}"
                  @click="setColorsFn(goodsListL,selectColorGroup.index,n)"
                >{{m.color}}</span>
              </div>
              <div class="commoditymiss">
                <table>
                  <tr>
                    <th>库存</th>
                    <th>规格</th>
                    <th>颜色</th>
                    <th>
                      <el-input
                        :precision="2"
                        :min="0"
                        :max="99999"
                        size="mini"
                        type="number"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        @input="selectDataAll"
                        v-model="selectData.all"
                        ref="allKey"  
                        name="allName"  
                      ></el-input>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in resultItem.goodsItem" :key="index">
                    <td>{{item.num}}</td>
                    <td>{{item.size}}</td>
                    <td>{{item.color}}</td>
                    <td>
                      <el-input
                        :precision="2"
                        :min="0"
                        :max="99999"
                        size="mini"
                        type="number"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        v-model="item.nums"
                        @input="setMoneyall"
                      ></el-input>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="Total">
              <h3>
                <Row>
                  <Col span="12">共: {{summary.totalPieces}} 件</Col>
                  <Col span="12">合计:￥ {{summary.totalMoney.toFixed(2)}}</Col>
                </Row>
              </h3>
            </div>
          </div>
        </Split>
      </div>
      <div slot="footer">
        <Button type="text" @click="commodityModal=false">取消</Button>
        <Button type="primary" @click="addsSelectItem(true)">确定</Button>
      </div>
    </Modal>
    <Modal v-model="opengreatHy" width="360">
      <p slot="header" style="text-align:center">
        <span>提示</span>
      </p>
      <div style="text-align:center">
        <p>当前没有会员卡收据账户，是否创建？</p>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="$router.push('/accountGl')">创建</Button>
      </div>
    </Modal>

    <Modal v-model="bfbdialg" width="450">
      <p slot="header" style="text-align:center">
        <span>修改值</span>
      </p>
      <div style="text-align:center">
        <ButtonGroup>
          <Button @click="sendBfb(100)" style="color: #ff7f7f;">原价</Button>
          <Button @click="sendBfb(99)">99%</Button>
          <Button @click="sendBfb(98)">98%</Button>
          <Button @click="sendBfb(97)">97%</Button>
          <Button @click="sendBfb(96)">96%</Button>
          <Button @click="sendBfb(95)">95%</Button>
          <Button @click="sendBfb(94)">94%</Button>
          <Button @click="sendBfb(93)">93%</Button>
          <Button @click="sendBfb(92)">92%</Button>
          <Button @click="sendBfb(91)">91%</Button>
          <Button @click="sendBfb(90)" style="color: #ff7f7f;">90%</Button>
          <Button @click="sendBfb(89)">89%</Button>
          <Button @click="sendBfb(88)">88%</Button>
          <Button @click="sendBfb(87)">87%</Button>
          <Button @click="sendBfb(86)">86%</Button>
          <Button @click="sendBfb(85)">85%</Button>
          <Button @click="sendBfb(84)">84%</Button>
          <Button @click="sendBfb(83)">83%</Button>
          <Button @click="sendBfb(82)">82%</Button>
          <Button @click="sendBfb(81)">81%</Button>
          <Button @click="sendBfb(80)" style="color: #ff7f7f;">80%</Button>              
          <Button @click="sendBfb(79)">79%</Button>
          <Button @click="sendBfb(78)">78%</Button>
          <Button @click="sendBfb(77)">77%</Button>
          <Button @click="sendBfb(76)">76%</Button>
          <Button @click="sendBfb(75)">75%</Button>
          <Button @click="sendBfb(74)">74%</Button>
          <Button @click="sendBfb(73)">73%</Button>
          <Button @click="sendBfb(72)">72%</Button>
          <Button @click="sendBfb(71)">71%</Button>
          <Button @click="sendBfb(70)" style="color: #ff7f7f;">70%</Button>
          <Button @click="sendBfb(69)">69%</Button>          
          <Button @click="sendBfb(68)">68%</Button>
          <Button @click="sendBfb(67)">67%</Button>
          <Button @click="sendBfb(66)">66%</Button>
          <Button @click="sendBfb(65)">65%</Button>
          <Button @click="sendBfb(64)">64%</Button>
          <Button @click="sendBfb(63)">63%</Button>
          <Button @click="sendBfb(62)">62%</Button>
          <Button @click="sendBfb(61)">61%</Button>
          <Button @click="sendBfb(60)" style="color: #ff7f7f;">60%</Button>
          <Button @click="sendBfb(59)">59%</Button>          
          <Button @click="sendBfb(58)">58%</Button>
          <Button @click="sendBfb(57)">57%</Button>
          <Button @click="sendBfb(56)">56%</Button>
          <Button @click="sendBfb(55)">55%</Button>
          <Button @click="sendBfb(54)">54%</Button>
          <Button @click="sendBfb(53)">53%</Button>
          <Button @click="sendBfb(52)">52%</Button>
          <Button @click="sendBfb(51)">51%</Button>
          <Button @click="sendBfb(50)" style="color: #ff7f7f;">50%</Button>
          <Button @click="sendBfb(49)">49%</Button>          
          <Button @click="sendBfb(48)">48%</Button>
          <Button @click="sendBfb(47)">47%</Button>
          <Button @click="sendBfb(46)">46%</Button>
          <Button @click="sendBfb(45)">45%</Button>
          <Button @click="sendBfb(44)">44%</Button>
          <Button @click="sendBfb(43)">43%</Button>
          <Button @click="sendBfb(42)">42%</Button>
          <Button @click="sendBfb(41)">41%</Button>
          <Button @click="sendBfb(40)" style="color: #ff7f7f;">40%</Button>
          <Button @click="sendBfb(39)">39%</Button>          
          <Button @click="sendBfb(38)">38%</Button>
          <Button @click="sendBfb(37)">37%</Button>
          <Button @click="sendBfb(36)">36%</Button>
          <Button @click="sendBfb(35)">35%</Button>
          <Button @click="sendBfb(34)">34%</Button>
          <Button @click="sendBfb(33)">33%</Button>
          <Button @click="sendBfb(32)">32%</Button>
          <Button @click="sendBfb(31)">31%</Button>
          <Button @click="sendBfb(30)" style="color: #ff7f7f;">30%</Button>
          <Button @click="sendBfb(29)">29%</Button>          
          <Button @click="sendBfb(28)">28%</Button>
          <Button @click="sendBfb(27)">27%</Button>
          <Button @click="sendBfb(26)">26%</Button>
          <Button @click="sendBfb(25)">25%</Button>
          <Button @click="sendBfb(24)">24%</Button>
          <Button @click="sendBfb(23)">23%</Button>
          <Button @click="sendBfb(22)">22%</Button>
          <Button @click="sendBfb(21)">21%</Button>
          <Button @click="sendBfb(20)" style="color: #ff7f7f;">20%</Button>
          <Button @click="sendBfb(19)">19%</Button>
          <Button @click="sendBfb(18)">18%</Button>
          <Button @click="sendBfb(17)">17%</Button>
          <Button @click="sendBfb(16)">16%</Button>
          <Button @click="sendBfb(15)">15%</Button>
          <Button @click="sendBfb(14)">14%</Button>
          <Button @click="sendBfb(13)">13%</Button>
          <Button @click="sendBfb(12)">12%</Button>
          <Button @click="sendBfb(11)">11%</Button>
          <Button @click="sendBfb(10)" style="color: #ff7f7f;">10%</Button>
          <Button @click="sendBfb(9)">&nbsp;&nbsp;9%</Button>
          <Button @click="sendBfb(8)">&nbsp;&nbsp;8%</Button>
          <Button @click="sendBfb(7)">&nbsp;&nbsp;7%</Button>
          <Button @click="sendBfb(6)">&nbsp;&nbsp;6%</Button>
          <Button @click="sendBfb(5)">&nbsp;&nbsp;5%</Button>
          <Button @click="sendBfb(4)">&nbsp;&nbsp;4%</Button>
          <Button @click="sendBfb(3)">&nbsp;&nbsp;3%</Button>
          <Button @click="sendBfb(2)">&nbsp;&nbsp;2%</Button>
          <Button @click="sendBfb(1)">&nbsp;&nbsp;1%</Button>
        </ButtonGroup>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="bfbdialg=false">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import FyImg from "../../components/Common/FyImg";
import { constants } from 'fs';
export default {
  components: { FyImg },
  data() {
    return {
      changelprice:JSON.parse(sessionStorage.getItem('access')).code,
      custType:"",
      key:'查看快捷键',//快捷键
      saleOpen:true,//销售开关
      id:null,//商品ID修改单个商品查询时使用
      colorSelectN:0,
      // 所有选择总数
      changenumber: 0,
      changeid: 0,
      allnumber: 0,
      allobj: [],
      cid: "",
      sid: "",
      // isTYPE: true,
      adminuser: JSON.parse(localStorage.getItem("adminUser")).name,
      opensTable: "0", //默认展开第一个
      customerList: [], //客户
      customerSearchTxt: "",
      allCustomerCount: 0, 
      allCustomerCountUnderFilter: 0, 
      isDynamicSearchShow: false,
      selectedUserName: "",
      customerPageObj: {
        "noSearch": 1
      },
      loadMoreBtnStatusObj: {
        "noSearch": "show"
      },
      isCallCustomerApi: false,
      isDynamicListShow: false,
      salesman: [], //业务员
      bankList: [], //结算账户
      isShowyouhui: false, //是否显示 ‘选择优惠’
      loadingOpeningOrder: false,
      discountListStatus: 0,
      discountList: [
        {
          //选择优惠
          id: 1,
          label: "无优惠",
          state: 0
        },
        {
          id: 2,
          label: "积分抵现",
          state: 2
        },
        {
          id: 3,
          label: "积分打折",
          state: 1
        },
        {
          id: 4,
          label: "会员卡",
          state: 4
        }
      ], //选择优惠
      pmoneyTpmoney: 0, //总会员卡余额
      zhekoulv: 100, //积分打折率
      constmerArr: [], //积分设置初始化
      formSelect: {
        user: "",
        store: "",
        adminuserid: JSON.parse(localStorage.getItem("adminUser")).id,
        salesperson: "",
        bank: "",
        bank2: "",
        noMoney: 0, //会员卡扣除
        realMoney: 0,
        realMoney2: 0,
        removeDecimal: 0, //抹零
        removeDecimals: 0, //抹零s
        discount: 1,
        nomoneys: 0, //本单欠款
        customerArrears: 0,
        customerIntegral: 0,
        thisBillIntegral: 0,
        showMoneys: 0, //总金额，
        merge: 0, //组合收款的实收合计
        total: 0, //总件数
        alljfNum: 0, //
        remark: ""
      },
      afterSelection: [], //发送的数据
      currentPageData: [], //当前页所选的数据
      searchNeirong: "",
      resultItem: {
        //默认显示详情
        single: null,
        img: "",
        name: "",
        price: "",
        num: "",
        colors: [],
        sizes: [],
        goodsItem: []
      },
      resultNum: 0,
      selectData: {
        all: 0
      },
      //总件
      summary: {
        totalPieces: 0,
        totalMoney: 0
      },

      //记录数选择数值
      selectColorGroup: {
        isCheckable: 0,
        index: 0
      },
      goodsListL: [], //当前页面的列表
      commodityModal: false,
      isOpenCb: false,
      split: 0.7,
      page: {
        current: 1, //当前页
        total: 1,
        page: 1,
        rows: 8
      },

      jfData: {}, //所有返回的积分数据
      opengreatHy: false, //创建会员卡提示弹框
      Lastmoney: 0, //最后实际付款
      normertext: "未收",
      normertexts: "补款",
      ispfprice: true, //判断是否显示批发价
      ischooseing: true,//判断是否批发客户
      ruleflag: false,
      getEdtiVal: "",
      bfbdialg: false,
      itemid: "", //修改百分比记录点击的是哪条数据
      itemi: "", //修改百分比记录点击的是哪条数据的子级
      // isHistoryOpen: "flag", //是否开启默认价格
      againSale:true,//再次开单标志，只用一次
      allRemoveDecimal:0,//统计总共摸了多少零
      // focusOnBlur:true,//监控el-input-number实时数据开关
      // cyclicOnDataNum:0,
      custSearchDate:{
        page:1,
        rows: 1000,
        name:null,
        phone:null
      },
      infoPageFlag:true,//首次进入页面标志
      turnCustFlag:false,//换客户标志
      memoryOption: "", //记忆数据
    };
  },
  mounted() {
    // if (this.$route.query.type == 1) {
    //   this.isTYPE = false;
    // }
  },
  created: function() {
    this.bindCloseDynamicSelectPopover();
    
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    //记忆数据
    this.memoryOption = JSON.parse(localStorage.getItem('memoryOption'+this.sid));
    // 是否开启历史价格
    // this.isHistoryOpen = localStorage.getItem("isHistoryOpen" + this.sid)
    //   ? true
    //   : false;
   
    this.formSelect.store = JSON.parse(localStorage.getItem("shop")).name;
    this.getGoodsList(this.cid, this.sid);
    this.getCustomerList(true);
    this.getAdminList();
    this.getBankList();
    this.getIntegralList();

    var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
    if (!PermisCode.includes("84")) {
      this.ruleflag = true;
    };
    //监听键盘
    document.addEventListener('keydown', this.handleKeyDown);
  },

  watch: {
    // 改变历史价格开关
    // isHistoryOpen(val) {
    //   console.log(val);
    //   val = val ? "1" : "";
    //   localStorage.setItem("isHistoryOpen" + this.sid, val, "1y");
    //   this.addsSelectItem(true);
    //   //抹零清零
    //   this.allRemoveDecimal = 0;
    //   this.formSelect.removeDecimal= 0; //抹零
    //   this.formSelect.removeDecimals=0;//抹零s
    // },
    //修改选择优惠方式
    "formSelect.discount": {
      deep: true,
      handler: function(newVal, oldVal) {
        /*每次修改优惠方式关闭组合收款*/
        this.isOpenCb = false;
        var istype = 0;
        this.bankList.forEach(item => {
          if (item.type == 6) {
            istype = item.type;
          }
        });

        /** 积分打折 **/
        if (newVal == 3) {
          let dzWays = this.constmerArr.sort((a, b) => {
            return a.dz * 1 - b.dz * 1;
          });
          let way = dzWays.find(val => {
            return this.formSelect.customerIntegral >= val.jf * 1;
          });
          if (way) {
            this.zhekoulv = way.dz;
          } else {
            this.zhekoulv = 100;
          }
        } else {
          this.zhekoulv = 100;
        }

        /** 判断优惠后的金额 **/
        //无优惠的时候
        this.Lastmoney = this.formSelect.showMoneys;
        this.formSelect.realMoney = this.formSelect.showMoneys;
        this.formSelect.removeDecimals = 0;
        if (newVal == 3) {
          this.Lastmoney = (this.Lastmoney * this.zhekoulv) / 100;
          this.formSelect.realMoney = this.Lastmoney;

          this.formSelect.nomoneys = this.Lastmoney - this.formSelect.merge;
        }
        this.formSelect.thisBillIntegral = Math.floor(
          this.Lastmoney / this.jfData.consume
        );
        if (newVal == 2) {
          if (
            this.formSelect.customerIntegral / this.jfData.employ >=
            this.formSelect.showMoneys
          ) {
            this.formSelect.alljfNum = this.formSelect.showMoneys;
            this.formSelect.realMoney = 0;
          } else {
            this.formSelect.alljfNum =
              this.formSelect.customerIntegral / this.jfData.employ;
            this.formSelect.realMoney = (
              this.formSelect.showMoneys - this.formSelect.alljfNum
            ).toFixed(2);
          }
          this.Lastmoney =
            this.formSelect.showMoneys - this.formSelect.alljfNum;
          this.formSelect.thisBillIntegral = 0;
        }
        if (newVal == 4) {
          if (this.pmoneyTpmoney >= this.Lastmoney) {
            this.formSelect.nomoneys = 0;
          } else {
            this.formSelect.nomoneys = 0;
          }
          //会员卡扣除金额
          this.formSelect.noMoney = this.formSelect.showMoneys;

          if (istype == 0) {
            this.opengreatHy = true;
            this.formSelect.discount = 1;
          }
        }
        if (newVal == 1) {
          this.formSelect.nomoneys = 0;
        }
      //抹零清零
      this.allRemoveDecimal = 0;
      }
    },
    /*搜索商品*/
    // searchNeirong: {
    //   deep: true,
    //   handler: function(newVal, oldVal) {
    //     this.searchNeirong = newVal.replace(">", ":");
    //     this.searchNeirong = newVal.replace("》", ":");
    //     this.$set(this.page, "page", 1);
    //     this.$set(this.page, "current", 1);
    //     this.getGoodsList(this.cid, this.sid);
    //   }
    // },
    // 修改客户判断
    "formSelect.user": {
      deep: true,
      handler: function(newVal, oldVal) {
        let selectedCustomer = this.customerList.find(user => this.formSelect.user === user.id) || {};
        this.selectedUserName = selectedCustomer.name || "";

        this.isFormSelectUser(newVal);
        
        this.isOpenCb = false;
        this.formSelect.nomoneys = 0;
        this.formSelect.removeDecimals = 0;
        this.formSelect.realMoney = this.formSelect.showMoneys;
        this.formSelect.realMoney2 = 0;
        this.formSelect.merge = this.formSelect.showMoneys;
        this.Lastmoney = this.formSelect.showMoneys;
        this.customerList.forEach((item, index) => {
          if (item.id == newVal) {
            if (item.customerType == 1) {
              //判断是否显示优惠
              this.ispfprice = true;
            } else {
              this.ispfprice = false;
            }
            if (item.money > 0) {
              //转换客户欠款
              this.formSelect.customerArrears = -item.money;
            } else {
              this.formSelect.customerArrears = Math.abs(item.money);
            }
            //客户积分
            this.formSelect.customerIntegral = item.integral;
          }
        });
      }
    },

    // 实收金额不能大于总金额
    "formSelect.realMoney": {
      deep: true,
      handler: function(newVal, oldVal) {
        newVal = newVal*1;//变数字
        this.formSelect.realMoney = newVal.toFixed(2);
        //实收合计
        this.formSelect.merge =
          this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
        this.formSelect.thisBillIntegral = Math.floor(
          this.Lastmoney / this.jfData.consume
        );
        if (this.formSelect.discount == 1) {
          this.formSelect.nomoneys =
            this.formSelect.showMoneys -
            this.formSelect.merge -
            this.formSelect.removeDecimals;
        } else if (this.formSelect.discount == 2) {
          this.formSelect.nomoneys =
            this.formSelect.showMoneys -
            this.formSelect.alljfNum -
            this.formSelect.merge -
            this.formSelect.removeDecimals;
          this.formSelect.thisBillIntegral = 0;
        } else if (this.formSelect.discount == 3) {
          this.formSelect.nomoneys = this.Lastmoney - this.formSelect.merge;
        }
      }
    },
    // 组合收款不能大于总金额

    "formSelect.realMoney2": {
      deep: true,
      handler: function(newVal, oldVal) {
        newVal = newVal*1;//变数字
        this.formSelect.realMoney2 = newVal.toFixed(2);
        //实收合计
        this.formSelect.merge =
          this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
        this.formSelect.thisBillIntegral = Math.floor(
          this.Lastmoney / this.jfData.consume
        );
        if (this.formSelect.discount == 1) {
          this.formSelect.nomoneys =
            this.formSelect.showMoneys -
            this.formSelect.merge -
            this.formSelect.removeDecimals;
        } else if (this.formSelect.discount == 2) {
          this.formSelect.nomoneys =
            this.formSelect.showMoneys -
            this.formSelect.alljfNum -
            this.formSelect.merge -
            this.formSelect.removeDecimals;
          this.formSelect.thisBillIntegral = 0;
        } else if (this.formSelect.discount == 3) {
          this.formSelect.nomoneys = this.Lastmoney - this.formSelect.merge;
        } else if (this.formSelect.discount == 4) {
        }
      }
    },

    /** 组合开关，如果关了就把该组合数据清零 **/
    isOpenCb: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.formSelect.bank2 = this.bankList[1].id;
        if (!newVal) {
          this.formSelect.realMoney2 = 0;
        }
      }
    },

    //扫码商品啊
    scanGoods: {
      deep: true,
      handler: function(val) {
        if (this.currentPageData == "" && null != val && val.id) {
          this.currentPageData.push(val);
        } else {
          var flags = true;
          for (var i = 0; i < this.currentPageData.length; i++) {
            if (this.currentPageData[i].id == val.id) {
              this.currentPageData[i].goodsItem.forEach(item => {
                item.nums++;
              });
              flags = false;
              break;
            }
          }
          if (flags) {
            if (null != val && val.id) {
              this.currentPageData.push(val);
            }            
          }
        }
        sessionStorage.setItem("gools", JSON.stringify(this.currentPageData));
        this.addsSelectItem(true);
      }
    },
    changenumber: {
      deep: true,
      handler: function(val) {
        let _this = this;
        if (_this.allobj.length == 0) {
          _this.allobj.push({ id: _this.changeid, num: _this.changenumber });
        } else {
          let state = true;
          _this.allobj.forEach((item,index) => {
            if (item.id == _this.changeid) {
              item.num = _this.changenumber;
              state = false;
              if(_this.changenumber == 0){
                _this.allobj.splice(index,1);
              }
              return;
            }
          });
          if (state) {
            _this.allobj.push({ id: _this.changeid, num: _this.changenumber });
          }
        }
        _this.allnumber = 0;
        _this.allobj.forEach(item => {
          _this.allnumber += item.num;
        });
      }
    },
  },
  computed: {
    scanGoods() {
      return this.$store.state.scanGoods;
    },
    filterCustomerList() {
      if (this.isDynamicSearchShow && this.customerSearchTxt !== "") {
        return this.customerList.filter(user => {
          let tempName = user.name || "";
          let tempPhone = user.phone || "";
          return tempName.includes(this.customerSearchTxt) || tempPhone.includes(this.customerSearchTxt);
        });
      }

      return this.customerList;      
    }
  },
  beforeDestroy() {
    this.$store.commit("clearScanGoods");
  },
  destroyed() {
   document.removeEventListener('keydown', this.handleKeyDown);//清除绑定的
  },  
  methods: {
    /* 修改百分比 */
    sendBfb(bf) {
      this.bfbdialg = false;
      this.afterSelection.forEach(alt => {
        if (alt.goodsid == this.itemid.goodsid) {
          alt.goodsItem[this.itemi].zkv = bf; //修改百分比
          if (this.ischooseing) {
            alt.goodsItem[this.itemi].lprice = this.itemid.lprice;
          } else {
            alt.goodsItem[this.itemi].pprice = this.itemid.pprice;
          }
        }
      });
      this.addReckonnumber();
    },
    //修改价格   item每条数据 i-goodsItem第几个 price价格 flag客户类别 type类别 1代表修改价格 2修改百分比 3修改数量
    editprice(item, i, price, flag, type) {
      if(this.custType == 0&&!JSON.parse(sessionStorage.getItem('access')).code.includes('128')){
        this.$Message.error('没有权限修改价格！');
        return;
      }

        let sessgoolsUpdate = JSON.parse(sessionStorage.getItem("gools"));
      if (!price) {
        price = 0;
      }
      if (type == 2) {
        this.bfbdialg = true;
        this.itemi = i;
        this.afterSelection.forEach(alt => {
          if (alt.goodsid == item.goodsid) {
            item.pprice = alt.goodsItem[i].pprice;
          }
        });
        this.itemid = item;
        return;
      }
      this.getEdtiVal = price;
      this.afterSelection.forEach(alt => {
        if (alt.goodsid == item.goodsid) {
          if (type == 1) {
            //修改单价
            if (flag) {
              /** 判断客户是否批发客户，计算不同的价格 **/
              alt.goodsItem[i].lprice = this.getEdtiVal;
              //修改缓存数据
              sessgoolsUpdate.forEach(suItems=>{
                if(suItems.goodsid == item.goodsid){
                  suItems.goodsItem[i].lprice = this.getEdtiVal;
                }
              });
            } else {
              alt.goodsItem[i].pprice = this.getEdtiVal;
              //修改缓存数据
              sessgoolsUpdate.forEach(suItems=>{
                if(suItems.goodsid == item.goodsid){
                  suItems.goodsItem[i].pprice = this.getEdtiVal;
                }
              });
            }
            alt.goodsItem[i].zkv = 100;
          } else {
            //修改数量
            if (
              (type == 3 && this.getEdtiVal == 0) ||
              (type == 3 && !this.getEdtiVal)
            ) {
              this.getEdtiVal = 1;
            }
            alt.goodsItem[i].nums = this.getEdtiVal;
            //修改缓存数据
            let nums = 0;
            sessgoolsUpdate.forEach(suItems=>{
              if(suItems.goodsid == item.goodsid){
                suItems.goodsItem[i].nums = this.getEdtiVal;//单品数量
                suItems.goodsItem.forEach(suItem=>{
                   nums+=suItem.nums;//商品总数量
                });
                suItems.nums = nums;
              }
            });
          }
        }
      });
      this.addReckonnumber();
      sessionStorage.setItem("gools", JSON.stringify(sessgoolsUpdate));
      
    },

    /** 修改总的单价 **/
    editallprice(item, flag, type) {
      console.log(JSON.parse(sessionStorage.getItem('access')).code);
      if(this.custType == 0&&!JSON.parse(sessionStorage.getItem('access')).code.includes('128')){
        this.$Message.error('没有权限修改价格！');
        return;
      }
      this.getEdtiVal = 0;
      this.$Modal.warning({
        render: h => {
          return h("InputNumber", {
            props: {
              value: 0,
              autofocus: true,
              min: 0,
              max: 999999
            },
            on: {
              input: val => {
                this.getEdtiVal = val;
              }
            }
          });
        },
        onOk: () => {
          let sessgoolsUpdate = JSON.parse(sessionStorage.getItem("gools"));
          if (this.getEdtiVal != "") {
            this.afterSelection.forEach(alt => {
              if (alt.goodsid == item.goodsid) {
                if (type == 1) {
                  //修改单价
                  if (flag) {
                    /** 判断客户是否批发客户，计算不同的价格 **/
                    alt.goodsItem.forEach(w => {
                      w.lprice = this.getEdtiVal;
                    });
                    //修改缓存数据
                    sessgoolsUpdate.forEach(suItems=>{
                      if(suItems.goodsid == item.goodsid){
                        suItems.goodsItem.forEach(suItem=>{
                          suItem.lprice = this.getEdtiVal;
                        });
                      }
                    });
                  } else {
                    alt.goodsItem.forEach(w => {
                      w.pprice = this.getEdtiVal;
                    });
                    //修改缓存数据
                    sessgoolsUpdate.forEach(suItems=>{
                      if(suItems.goodsid == item.goodsid){
                        suItems.goodsItem.forEach(suItem=>{
                          suItem.pprice = this.getEdtiVal;
                        });
                      }
                    });
                  }
                  alt.goodsItem.forEach(w => {
                    w.zkv = 100;
                  });
                } else {
                  //修改数量
                  alt.goodsItem[i].nums = this.getEdtiVal;
                }
              }
            });
            this.addReckonnumber();
            sessionStorage.setItem("gools", JSON.stringify(sessgoolsUpdate));
          }
        }
      });
    },

    /** 未收，全款功能**/
    normerbtn() {
      if (this.normertext == "未收") {
        this.normertext = "全款";
        this.formSelect.realMoney = 0;
      } else {
        this.normertext = "未收";
        this.formSelect.realMoney = this.Lastmoney;
      }
    },
    /** 补款，清零**/
    normerbtns() {
      if (this.normertexts == "补款") {
        this.normertexts = "清零";
        this.formSelect.realMoney2 = this.Lastmoney - this.formSelect.realMoney;
      } else {
        this.normertexts = "补款";
        this.formSelect.realMoney2 = 0;
      }
    },
    //加载缓存中的再次开单
    getSessionData() {
      var tabledata = JSON.parse(sessionStorage.getItem("openorder"));
      tabledata.goodslist.sort((a, b) => {
          return b.sortTime - a.sortTime;
      });
      //回填销售单上的数据
      this.customerList.forEach(item=>{
        if(item.customerType==1){
          this.ischooseing=false
        }else {
          this.ischooseing=true
        }
      })     
      this.formSelect.salesperson = tabledata.adminid*1;//销售员
      this.formSelect.user = tabledata.customerid;//客户
      this.customerList.forEach((item,index)=>{
        if(item.id == this.formSelect.user){
          if( item.username != null) {
            this.isShowyouhui = false;
          } else {
            this.isShowyouhui = true;
          }
        }
      });
      this.afterSelection = tabledata.goodslist; //商品列表
      this.formSelect.showMoneys = tabledata.totalmoney; //商品金额
      this.formSelect.realMoney = tabledata.totalmoney; //实付款
      this.Lastmoney = tabledata.totalmoney; //总金额
      this.formSelect.discount = 1;
      this.formSelect.remark = tabledata.remarks || tabledata.way;
      this.allnumber = tabledata.total;//总数量

      tabledata.goodslist.forEach((item)=>{
        this.allobj.push({ id: item.id, num: item.nums });
        this.currentPageData.push(item);     
      });      
      //加入缓存的数据
      sessionStorage.setItem("gools",JSON.stringify(tabledata.goodslist));
    },
    loadMoreCurstomer() {
      this.getCustomerPage();
      this.getCustomerList(false);
    },
    getLoadMoreStatusObj(resDataLength) {
      if (this.customerSearchTxt === "") {
        this.loadMoreBtnStatusObj["noSearch"] = this.customerList.length < this.allCustomerCount ? "show" : "hide";
      } else {
        let pageKey = this.customerSearchTxt;
        if (resDataLength === 0) {
          this.loadMoreBtnStatusObj[pageKey] = "hide";
        } else {
          this.loadMoreBtnStatusObj[pageKey] = this.filterCustomerList.length < this.allCustomerCountUnderFilter ? "show" : "hide";
        }
      }
    },
    mergeNewDataIntoCustomerList(newCustomerData) {
      let allIdInCustomerList = this.customerList.map(customer => customer.id);
      let newCustomerList = JSON.parse(JSON.stringify(this.customerList));
      newCustomerData.forEach(customer => {
        if (!allIdInCustomerList.includes(customer.id)) {
          newCustomerList.push(customer);
        }
      });
      this.customerList = newCustomerList;
    },
    getCustomerPage() {
      if (this.customerSearchTxt === "") {
        this.customerPageObj["noSearch"]++;
        this.custSearchDate.page = this.customerPageObj["noSearch"];
      } else {
        let pageKey = this.customerSearchTxt;
        this.customerPageObj[pageKey] = this.customerPageObj[pageKey] || 0;
        this.customerPageObj[pageKey]++;
        this.custSearchDate.page = this.customerPageObj[pageKey];
      }
    },
    isLoadMoreBtnShow() {
      if (this.loadMoreBtnStatusObj["noSearch"] === "hide") {
        return false;
      }
      
      if (this.customerSearchTxt === "") {
        return this.loadMoreBtnStatusObj["noSearch"] !== "hide";
      }

      let pageKey = this.customerSearchTxt;

      if (this.loadMoreBtnStatusObj[pageKey] === "hide") {
        return false;
      }
      if (this.loadMoreBtnStatusObj[pageKey] === "show") {
        return true;
      }

      // 如果输入2256不需要加载更多按钮，那么输入22562, 22563, 12256等条件，也不需要加载更多
      for (let txtKey in this.loadMoreBtnStatusObj) {
        if (this.loadMoreBtnStatusObj[txtKey] === "hide" && this.customerSearchTxt.includes(txtKey)) {
          return false;
        }
      }
      
      return true;
    },
    isNoDataShow() {
      if (!this.isLoadMoreBtnShow() && this.filterCustomerList.length === 0) {
        return true;
      }

      return false;
    },
    
    
    handleFirstGetCusromerList(res) {
      if (res.code == 200) {
        if (res.data.length != 0) {
            this.customerList = res.data;
            this.formSelect.user = this.customerList[0].id;
            /**判断零散客户**/
            if (this.customerList[0].username != null) {
              this.isShowyouhui = false;
            } else {
              this.isShowyouhui = true;
            }
            this.formSelect.customerArrears = this.customerList[0].money;
            this.formSelect.customerIntegral = this.customerList[0].integral;
            this.pmoneyTpmoney =this.customerList[0].tmoney + this.customerList[0].pmoney;
        }
        //再次开单的回填客户，其他的回填记忆数据
        if (this.$route.query.type != undefined) {
          // 回填客户
          var tabledata = JSON.parse(sessionStorage.getItem("openorder"));
          this.formSelect.user = tabledata.customerid;//客户
          this.customerList.forEach((item,index)=>{
            if(item.id == this.formSelect.user){
              if( item.username != null) {
                this.isShowyouhui = false;
              } else {
                this.isShowyouhui = true;
              }
            }
          });
        } else if(null != this.memoryOption && typeof(this.memoryOption) != "undefined" && this.memoryOption.customerPfFlag) {//记忆数据，批发类型的客户显示批发散客
          this.formSelect.user = this.customerList[1].id;
          this.ischooseing = false;
        }            
      } else {
        this.$Message.warning(res.msg);
      }
    },
    //获取客户列表
    getCustomerList(isFirstCallApi) {
      this.isCallCustomerApi = true;
      this.$Api.getCustomerListNew({
        cid: this.cid,
        sid: this.sid,
        page: this.custSearchDate.page,
        rows: this.custSearchDate.rows,
        name: this.customerSearchTxt,
        phone: this.customerSearchTxt,          
        isdel: 1
      }).then(res => {
        this.allCustomerCountUnderFilter = res.count || 0;
        if (this.customerSearchTxt === "") {
          this.allCustomerCount = res.count || 0;
        }
        
        if (isFirstCallApi) {
          this.handleFirstGetCusromerList(res);
        } else {
          this.mergeNewDataIntoCustomerList(res.data);
        }

        this.getLoadMoreStatusObj(res.data.length);
        this.isCallCustomerApi = false;
      });
    },
    //获取业务员列表
    getAdminList() {
      let adminUser = JSON.parse(localStorage.getItem("adminUser"));
      let flag = true;

      this.$Api
        .getAdminList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000,
          isdel: 0,
          addition: 1
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data != "") {
              this.salesman = [];
              res.data.forEach(item => {
                if (item.role) {
                  var rule = item.role.code.split(",");
                  //39是销售权限
                  if (rule.indexOf("39") > -1) {
                    this.salesman.push(item);
                    //新开销售单时没有当前的业务员的从缓冲中加入
                    if(item.id == adminUser.id){
                      flag=false;
                    }
                  }
                }
              });
              if(flag){
                let item = [];
                item.id=adminUser.id;
                item.name=adminUser.name;
                this.salesman.push(item);
              }
            }
            //初始销售员
            if(this.formSelect.salesperson == null || this.formSelect.salesperson == ""){
              this.formSelect.salesperson = JSON.parse(localStorage.getItem("adminUser")).id;
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //获取所有商品列表
    getGoodsList(flag) {
      if(flag){
        this.page.page = 1;
        this.page.current = 1;
      }
      this.$Api
        .getGoodsListNew({
          cid: this.cid,
          sid: this.sid,
          page: this.page.page,
          rows: this.page.rows,
          condition: this.searchNeirong, //查询内容
          id: this.id //商品ID
        })
        .then(res => {
          if (res.code == 200) {
            this.page.total = res.count;
            this.goodsListL = res.data;
            /**再次开单回填**/
            if (this.$route.query.type != undefined && this.againSale) {
              this.getSessionData(); //再次开单 
            }
            this.setDataListFn(this.goodsListL, 0);
            /**再次开单初始化历史价格标志数据**/
            if (this.$route.query.type != undefined && this.againSale) {
              this.againSale = false;
              this.addsSelectItem(true);
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    setDataListFn(getData, i) {
      this.$Api
        .getGoodsId({
          id: getData[i].id
        })
        .then(res => {
          if (res.code == 200) {
            getData[i] = res.data;

            this.resultItem.single = getData[i].id;
            this.resultItem.goodsimg = getData[i].goodsimg;
            this.resultItem.name = getData[i].name;
            this.resultItem.price = getData[i].lprice;
            this.resultItem.lprice = getData[i].pprice;
            this.resultItem.num = getData[i].num;
            this.resultItem.colors = getData[i].colors;
            this.selectColorGroup.index = i; //点击的商品下标
            /*** 回填缓存中的数据 没有缓存数据的也会默认把第一个商品先缓存了**/
            var sessgools = JSON.parse(sessionStorage.getItem("gools"));
            if (sessgools != null) {
              sessgools.forEach((item, index) => {
                this.goodsListL.forEach((m, n) => {
                  if (item.id == m.id) {
                    // this.goodsListL[n].goodsItem = sessgools[index].goodsItem;
                    this.goodsListL[n].nums = sessgools[index].nums;
                  }
                  if (getData[i].id == m.id) {
                    //有缓存数据的整个给商品列表，再缓存中有的单品数据替换到商品列表中的单品数据
                    let gItem = getData[i].goodsItem; //单品数量
                    let sItem = sessgools[index].goodsItem;
                    for (let o = 0; o < gItem.length; o++) 
                    {
                      for (let p = 0; p < sItem.length; p++) 
                      {
                        let gItemSurper = gItem[o].goodsid +""+ gItem[o].sizeid +""+ gItem[o].colorid;
                        let sItemSurper = sItem[p].goodsid +""+ sItem[p].sizeid +""+ sItem[p].colorid
                        if (gItemSurper == sItemSurper) 
                        {
                          gItem[o].nums = sItem[p].nums;
                        }
                      }
                    }
                    //再次开始单时缺的数据，统一使用当前选的商品。
                    let colors = getData[i].colors; //颜色组
                    let sizes = getData[i].sizes; //规格组
                    let kcnum = getData[i].num; //单品数量
                    this.goodsListL[n].goodsItem = gItem;
                    this.goodsListL[n].num = kcnum;
                    this.goodsListL[n].colors = colors;
                    this.goodsListL[n].sizes = sizes;
                  }
                });
              });
            }
            this.setMoneyall();
            this.setColorsFn(getData, i, 0);
          }
        });
    },
    //选择的颜色
    setColorsFn(getData, i, n) {
      this.colorSelectN = n;
      this.selectData.all = 0;
      this.resultNum = 0;
      this.selectColorGroup.isCheckable = n;
      var resultColor = getData[i].colors[n].color;
      var resultGoodsItem = getData[i].goodsItem;
      this.resultItem.goodsItem = [];
      resultGoodsItem.forEach((k, v) => {
        if (resultGoodsItem[v].color == resultColor) {
          this.resultItem.goodsItem.push(k);
        }
      });
    },
    //修改总数量
    selectDataAll(nn) {
      let n = parseInt(nn);
      if (n == this.resultNum + 1) {
        this.resultItem.goodsItem.forEach((item, index) => {
          this.resultItem.goodsItem[index].nums++;
        });
      } else if (n + 1 == this.resultNum) {
        this.resultItem.goodsItem.forEach((item, index) => {
          if (this.resultItem.goodsItem[index].nums <= 0) {
            this.resultItem.goodsItem[index].nums = 0;
          } else {
            this.resultItem.goodsItem[index].nums--;
          }
        });
      } else {
        this.resultItem.goodsItem.forEach((item, index) => {
          if (
            n > this.resultItem.goodsItem[index].nums ||
            n < this.resultItem.goodsItem[index].nums
          ) {
            this.resultItem.goodsItem[index].nums = n;
          }
        });
      }
      this.resultNum = n;
      this.setMoneyall();
    },
    setMoneyall() {
      /** 计算当前向的总件数和总金额 **/
      var allPieces = 0;
      var checks = 0;
      this.goodsListL[this.selectColorGroup.index].goodsItem.forEach((value, index) => {
          let num = this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums
          this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums = num*1
          checks = checks + value.nums;
          allPieces = allPieces+this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums;
      });
      //计算酸选的总数
      this.goodsListL[this.selectColorGroup.index].nums = checks;

      if (checks == 0) {
        var sessgools = JSON.parse(sessionStorage.getItem("gools"));
        var goodID = this.goodsListL[this.selectColorGroup.index];
        if (sessgools != null) {
          sessgools.forEach((item, index) => {
            if (item.id == goodID.id) {
              sessgools.splice(index, 1);
            }
          });
          this.currentPageData.forEach((item, index) => {
            if (item.id == goodID.id) {
              this.currentPageData.splice(index, 1);
            }
          });
          sessionStorage.setItem("gools", JSON.stringify(sessgools));
        }
      }
      //总件数
      this.summary.totalPieces = allPieces;
      this.changeid = this.goodsListL[this.selectColorGroup.index].id;
      this.changenumber = allPieces;
      //总金额
      if (!this.ispfprice) {
        this.summary.totalMoney = allPieces * this.resultItem.price;
      } else {
        this.summary.totalMoney = allPieces * this.resultItem.lprice;
      }
      this.selectDataSingle();
    },
    //设置缓存所选择的项
    selectDataSingle() {
      //首次进入如果有缓存数据添加到当前页所选项中
      if (this.infoPageFlag && JSON.parse(sessionStorage.getItem("gools")) != null) {
        this.currentPageData = JSON.parse(sessionStorage.getItem("gools"));
        this.infoPageFlag = false;
      }
      var listArray = null;
      /** 储存当前页的所选数据 **/
      for (var i = 0;i < this.goodsListL[this.selectColorGroup.index].goodsItem.length;i++)
      {
        if (this.goodsListL[this.selectColorGroup.index].goodsItem[i].nums != 0) {
          listArray = this.goodsListL[this.selectColorGroup.index];
          break;
        }
      }
      if (listArray != null) {
        if (this.currentPageData == "") {
          this.currentPageData.push(listArray);
        } else {
          var flags = true;
          for (var i = 0; i < this.currentPageData.length; i++) {
            if (this.currentPageData[i].id == listArray.id) {
              this.currentPageData[i] = listArray;
              flags = false;
              break;
            }
          }
          if (flags) {
            this.currentPageData.push(listArray);
          }
        }
        sessionStorage.setItem("gools", JSON.stringify(this.currentPageData));
      }
    },
    //添加按钮
    async addsSelectItem(str) {
      var getGools = JSON.parse(sessionStorage.getItem("gools"));
      this.afterSelection = [];
      var listArray1 = [];
      if (getGools == null) {
        this.commodityModal = false;
        return;
      }
      //获取历史价格
      let list= [];
      if(JSON.parse(localStorage.getItem("shop")).isHistoryOpen==1 && getGools.length>0){
          let goodsIds = [];//商品IDs，
          getGools.forEach((item, index) => {
            goodsIds.push(item.id);  
          });
          if(JSON.parse(localStorage.getItem("shop")).isSyncPrice){
            await this.$Api.getHistoryGoodsLprice({
            sid: this.sid,
            cusId: this.formSelect.user,
            goodsIds: goodsIds.join(","),
            isSyncPrice: JSON.parse(localStorage.getItem("shop")).isSyncPrice
          }).then(res => {
            list = res.data;
          }).catch(res =>{
          });
          }else{
            await this.$Api.getHistoryGoodsLprice({
            sid: this.sid,
            cusId: this.formSelect.user,
            goodsIds: goodsIds.join(",")
          }).then(res => {
            list = res.data;
          }).catch(res =>{
          });
        }
      }else if(JSON.parse(localStorage.getItem("shop")).isSyncPrice==1&&getGools.length>0){
        let goodsIds = [];//商品IDs，
          getGools.forEach((item, index) => {
            goodsIds.push(item.id);  
          });
          if(JSON.parse(localStorage.getItem("shop")).isSyncPrice){
            await this.$Api.getHistoryGoodsLprice({
            sid: this.sid,
            cusId: this.formSelect.user,
            goodsIds: goodsIds.join(","),
            isSyncPrice: JSON.parse(localStorage.getItem("shop")).isSyncPrice
          }).then(res => {
            list = res.data;
          }).catch(res =>{
          });
          }else{
            await this.$Api.getHistoryGoodsLprice({
            sid: this.sid,
            cusId: this.formSelect.user,
            goodsIds: goodsIds.join(",")
          }).then(res => {
            list = res.data;
          }).catch(res =>{
          });
          }
      }
      
      //整合已选商品数据，有历史价格的把现有价格替换掉
      let num = 0;//序号
      getGools.forEach((item, index) => {//商品
        num++;
        if (JSON.stringify(item) != "{}") {
          var itemArray = [];
          item.goodsItem.forEach((m, v) => {//单品
            //有历史价格替换掉现有价格
            if (m.nums != 0) {
              let historyPrice;
              let historyTime;
              let buyQuantity;
              let saleItemBuyTime;
              try {
                  //先看单品有无对应的历史价格
                  list.forEach((l,ls) =>{
                    if(l.supperId == (m.goodsid + "" + m.colorid + "" + m.sizeid)){
                      historyPrice = l.lprice;
                      historyTime = l.time;
                      buyQuantity=l.quantity;
                      saleItemBuyTime=l.saleItemBuyTime;
                      throw("中止循环");
                    }
                  });
                  //单品没有的按商品再找
                  if(!historyPrice){
                    list.forEach((l,ls) =>{
                      if(l.marketgoodsid == m.goodsid){
                        historyPrice = l.lprice;
                        historyTime = l.time;
                        buyQuantity=l.quantity;
                        saleItemBuyTime=l.saleItemBuyTime;
                        throw("中止循环");
                      }
                    });
                  }                     
              } catch (error) {
                  console.log('done')
              }
              let index = JSON.parse(localStorage.getItem("shop")).scanimg == 1 ? num+".":"";
              //有历史价格的说明是复购商品，商品名字中添加复购标志
              if(!item.goodsnameCopy){
                item.goodsnameCopy = item.name;
              }
              
              if(historyTime){
                item.name = index+"补"+item.goodsnameCopy;
                item.goodsname = index+"补"+item.goodsnameCopy;
                
              }else{
                item.name = index+""+item.goodsnameCopy;
                item.goodsname = index+""+item.goodsnameCopy;
              }   
                             
              if(JSON.parse(localStorage.getItem("shop")).isHistoryOpen==1 && list!=null && list.length>0){
                if(historyPrice){
                  m.buyQuantity=buyQuantity;
                  m.saleItemBuyTime=saleItemBuyTime;
                  //零售客户历史价格标志
                  // if (item.lprice != historyPrice) {
                  //   m.lOldIcon = true;
                  // } else {
                  //   m.lOldIcon = false;
                  // }
                  // //批发客户历史价格标志
                  // if (item.pprice != historyPrice) {
                  //   m.pOldIcon = true;
                  // } else {
                  //   m.pOldIcon = false;
                  // }
                  m.lOldIcon = true;
                  m.pOldIcon = true;
                  m.lprice = historyPrice;//零售价格
                  m.pprice = historyPrice;//批发价格
                }else{
                  m.buyQuantity=0;
                  m.saleItemBuyTime=0;
                  m.lOldIcon = false;//零售客户历史价格标志
                  m.pOldIcon = false;//批发客户历史价格标志
                  //换客户了价格恢复，没换的使用已有价格
                  if(this.turnCustFlag){
                  m.lprice = item.lprice;
                  m.pprice = item.pprice; 
                  }else{
                  m.lprice == null ? m.lprice = item.lprice:m.lprice;
                  m.pprice == null ? m.pprice = item.pprice: m.lprice; 
                  }
                }
              }else if(JSON.parse(localStorage.getItem("shop")).isSyncPrice && list!=null && list.length>0){
                if(historyPrice){
                  m.buyQuantity=buyQuantity;
                  m.saleItemBuyTime=saleItemBuyTime;
                  // //零售客户历史价格标志
                  // if (item.lprice != historyPrice) {
                  //   m.lOldIcon = true;
                  // } else {
                  //   m.lOldIcon = false;
                  // }
                  // //批发客户历史价格标志
                  // if (item.pprice != historyPrice) {
                  //   m.pOldIcon = true;
                  // } else {
                  //   m.pOldIcon = false;
                  // }
                  m.lOldIcon = true;
                  m.pOldIcon = true;
                  m.lprice = historyPrice;//零售价格
                  m.pprice = historyPrice;//批发价格
                }else{
                  m.buyQuantity=0;
                  m.saleItemBuyTime=0;
                  m.lOldIcon = false;//零售客户历史价格标志
                  m.pOldIcon = false;//批发客户历史价格标志
                  //换客户了价格恢复，没换的使用已有价格
                  if(this.turnCustFlag){
                  m.lprice = item.lprice;
                  m.pprice = item.pprice; 
                  }else{
                  m.lprice == null ? m.lprice = item.lprice:m.lprice;
                  m.pprice == null ? m.pprice = item.pprice: m.lprice; 
                  }
                }
              }else{
                m.buyQuantity=0;
                m.saleItemBuyTime=0;
                m.lOldIcon = false;//零售客户历史价格标志
                m.pOldIcon = false;//批发客户历史价格标志
                //换客户了价格恢复，没换的使用已有价格
                if(this.turnCustFlag){
                  m.lprice = item.lprice;
                  m.pprice = item.pprice; 
                }else{
                  m.lprice == null ? m.lprice = item.lprice:m.lprice;
                  m.pprice == null ? m.pprice = item.pprice: m.lprice; 
                }
              }
              m.zkv = 100;
              itemArray.push(m);
            }
          });
          if (itemArray != "") {
            (item.goodsid = item.id),
              (item.goodsname = item.name),
              (item.goodsItem = itemArray),
              listArray1.push(item);
            itemArray = [];
          }
        }
      });
      //遍历后的商品,展示在已选列表中
      if (this.afterSelection == "") {
        this.afterSelection = listArray1;
      } else {
        listArray1.forEach((item, index) => {
          if (this.afterSelection.indexOf(item) == -1) {
            this.afterSelection.splice(index, 1, item);
          } else {
            this.afterSelection.push(item);
          }
        });
      };
      this.turnCustFlag = false;//换客户标志
      if (str) {
        this.commodityModal = false;
      };
      this.addReckonnumber();
      //回填处理好的已选商品
      sessionStorage.setItem("gools",JSON.stringify(getGools));
    },
    //添加按钮计算金额
    addReckonnumber() {
      this.formSelect.showMoneys = 0;
      this.formSelect.total = 0;
      this.afterSelection.forEach((item, index) => {
        item.goodsItem.forEach((m, n) => {
          if (this.ischooseing) {
            this.formSelect.showMoneys += m.nums * m.lprice * (m.zkv / 100);
          } else {
            this.formSelect.showMoneys += m.nums * m.pprice * (m.zkv / 100);
          }
          this.formSelect.total += m.nums;
        });
      });

      this.setjfFn();
      //实收合计金额
      this.formSelect.merge =
        this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;

      if (this.formSelect.discount == 1) {
        //实收1金额
        this.formSelect.realMoney = this.formSelect.showMoneys;
        //合计金额=支付1+支付2+优惠金额
        this.Lastmoney = this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
      } else if (this.formSelect.discount == 2) {
        if (this.formSelect.alljfNum < this.formSelect.showMoneys) {
          this.formSelect.realMoney =
            this.formSelect.showMoneys - this.formSelect.alljfNum;
          this.formSelect.merge =
            this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
          this.Lastmoney = this.formSelect.merge;
        } else {
          this.formSelect.realMoney = 0;
          this.Lastmoney = 0;
        }
      } else if (this.formSelect.discount == 3) {
        this.Lastmoney = (this.formSelect.showMoneys * this.zhekoulv) / 100;
        this.formSelect.realMoney =
          (this.formSelect.showMoneys * this.zhekoulv) / 100;
      } else if (this.formSelect.discount == 4) {
        this.Lastmoney = this.formSelect.showMoneys;
      }

      //本单获得积分
    },

    //抹零
    moling() {
      //抹零不能大于合计金额
      if (this.formSelect.removeDecimal*1 >= this.formSelect.realMoney*1) {
        this.$Message.warning("抹零不能大于实收金额");
        return;
      } else {
        //合计金额-抹零
        this.Lastmoney = this.Lastmoney - this.formSelect.removeDecimal*1;

        //值1-抹零
        this.formSelect.realMoney =
        this.formSelect.realMoney - this.formSelect.removeDecimal*1;
        this.formSelect.removeDecimals =
        this.formSelect.removeDecimals + this.formSelect.removeDecimal*1;
        //统计抹零总额
        this.allRemoveDecimal = this.allRemoveDecimal+this.formSelect.removeDecimal*1;
        //抹零成功重新赋值0
        this.formSelect.removeDecimal = 0;
        this.formSelect.noMoney =
        this.formSelect.noMoney - this.formSelect.removeDecimals;
      }
    },
    setjfFn() {
      if (this.jfData.consume > this.jfData.integral) {
        this.formSelect.thisBillIntegral = Math.floor(
          (this.Lastmoney / this.jfData.consume) * this.jfData.integral
        );
      } else {
        this.formSelect.thisBillIntegral = Math.floor(
          this.Lastmoney * this.jfData.integral
        );
      }
      //共抵扣积分多少钱
      this.formSelect.alljfNum = Math.floor(
        (this.formSelect.customerIntegral / this.jfData.employ) *
          this.jfData.deposit
      );
      if (this.formSelect.alljfNum > this.formSelect.showMoneys) {
        this.formSelect.alljfNum = this.formSelect.showMoneys;
      }
    },
    //重新编辑
    editSendData(data) {
      this.commodityModal = true;
      //单个商品编辑重新查询，goodsname和goodscode有可以重复加上ID。
      this.searchNeirong = data.goodscode;
      this.id=data.id;
      this.onChange(1);
      //加ID后影响商品列表的查询，把ID置空去掉
      this.id = null;
    },

    //删除
    delSendData(k, index) {
      let _this = this;
      //清楚缓存中的商品
      var sessgools = JSON.parse(sessionStorage.getItem("gools"));
      if (sessgools != null) {
        sessgools.forEach((item, index) => {
          if (k.id == item.id) {
            sessgools.splice(index, 1);
          }
        });
        sessionStorage.setItem("gools", JSON.stringify(sessgools));
      }
      //删除记录的数据
      _this.afterSelection.splice(index, 1);
      //当前页面选择的数据
      _this.currentPageData = _this.afterSelection;
      //如果删除的商品在当前商品列表中把列表中的这个商品清零
      _this.goodsListL.forEach((item, index) => {
        if (k.id == item.id) {
          item.nums = 0;
          if(item.goodsItem){
            item.goodsItem.forEach((m, n) => {
              m.nums = 0;
            });
          }
        }
      });
      //重新计算总金额和数量
      _this.formSelect.showMoneys = 0;
      _this.formSelect.total = 0;
      _this.afterSelection.forEach((item, index) => {
        item.goodsItem.forEach((m, n) => {
          _this.formSelect.showMoneys += m.nums * item.lprice;
          _this.formSelect.total += m.nums;

        });
      });

      /*11-12添加重新调用按钮 因为删除的时候没发从新计算合计价格还是之前的总价*/
      this.addReckonnumber();
      /*11-12添加重新调用按钮*/

      _this.isOpenCb = false;
      _this.formSelect.discount = 1;

      //本单获得积分
      this.setjfFn();
      //删除商品 更新下序号
      this.addsSelectItem(true);

      _this.changeid = k.id;//计算总数量
      this.changenumber = 1;
      this.changenumber = 0;//计算总数量
    },

    //修改分页
    onChange(e) {
      this.page.page = e;
      this.getGoodsList(); //加载分页数据
    },
    //获取银行卡
    getBankList() {
      this.$Api
        .getBankList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000
        })
        .then(res => {
          if (res.code == 200) {
            this.bankList = res.data;
            this.formSelect.bank = res.data[0].id;
            //记忆数据
            if(null != this.memoryOption && typeof(this.memoryOption) != "undefined" 
              && this.memoryOption.bankid && this.memoryOption.bankid != "")
            {
              this.formSelect.bank = this.memoryOption.bankid;
            }            
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //积分规则
    getIntegralList() {
      this.$Api
        .getIntegralList({
          cid: this.cid
        })
        .then(res => {
          if (res.code == 200) {
            this.discountListStatus = res.data[0].status;
            this.jfData = res.data[0];
            if (this.jfData.constmer && this.jfData.constmer.length) {
              this.constmerArr = JSON.parse(this.jfData.constmer);
            }
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    /** 修改客户判断是否红色客户 **/
    isFormSelectUser(val) {
      console.log("val: ", val);
      this.customerList.forEach((item, index) => {
        if (item.id == val) {
          this.formSelect.showMoneys = 0;
          console.log("名字 ",item.name );
          
          this.custType = item.customerType;
          console.log("客户类型 ",this.custType );
          //重新获取商品价格
          if (item.customerType == 1) {
            this.ischooseing = false;
            this.addsSelectItem(true);
            // this.afterSelection.forEach((item, index) => {
              //   item.goodsItem.forEach((m, n) => {
                //     this.formSelect.showMoneys += m.nums * m.pprice * (m.zkv / 100);
            //   });
            // });
          } else {
            this.ischooseing = true;//判断是否批发客户
            this.turnCustFlag = false,//换客户标志
            this.addsSelectItem(true);
            // this.afterSelection.forEach((item, index) => {
            //   item.goodsItem.forEach((m, n) => {
            //     this.formSelect.showMoneys += m.nums * m.lprice * (m.zkv / 100);
            //   });
            // });
          }
          if (item.username != null) {
            this.isShowyouhui = false;
          } else {
            this.isShowyouhui = true;
          }
        }
        this.formSelect.discount = 1;
        if (item.id == val) {
          this.pmoneyTpmoney = item.tmoney + item.pmoney;
        }
      });
      this.turnCustFlag = true;//换客户标志
      this.formSelect.realMoney = this.formSelect.showMoneys;
      //实收合计金额
      this.formSelect.merge =
        this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
      //合计金额=支付1+支付2+优惠金额
      this.Lastmoney = this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
      //抹零清零
      this.allRemoveDecimal = 0;
    },
    //出售开单
    openingOrder() {
      if(this.afterSelection.length == 0){
        this.$Message.warning("请添加商品");
        return false;
      }
      //禁止负库存判断
      if(JSON.parse(localStorage.getItem("shop")).voiceenbdate == 1){
        this.afterSelection.forEach((goods, index) => {
          goods.goodsItem.forEach((item, index) => {
            if(item.nums>0 && item.nums>item.num){
              this.$Message.warning(goods.name+"|库存数量不足！");
              throw SyntaxError();
            }
          });
        });
      }      
      //变数字类型
      this.formSelect.realMoney = this.formSelect.realMoney*1;
      this.formSelect.realMoney2 = this.formSelect.realMoney2*1;

      /***
       * 是否组合收款
       * **/
      var PortfolioCollection;
      if (this.isOpenCb) {
        if (!this.formSelect.realMoney) {
          this.formSelect.realMoney = 0;
        }
        if (!this.formSelect.realMoney2) {
          this.formSelect.realMoney2 = 0;
        }

        PortfolioCollection = [
          {
            bankid: this.formSelect.bank,
            money: this.formSelect.realMoney.toFixed(2),
            yifu: true,
            quankuan: false
          },
          {
            bankid: this.formSelect.bank2,
            money: this.formSelect.realMoney2.toFixed(2),
            yifu: true,
            quankuan: false
          }
        ];
      } else {
        this.formSelect.realMoney2 = 0;
        if (!this.formSelect.realMoney) {
          this.formSelect.realMoney = 0;
        }
        PortfolioCollection = [
          {
            bankid: this.formSelect.bank,
            money: this.formSelect.realMoney.toFixed(2),
            yifu: true,
            quankuan: false
          }
        ];
      }
      /** 抵现剩余 **/
      var dixianshengyu = 0;
      if (this.formSelect.discount == 2) {
        dixianshengyu = this.formSelect.showMoneys - this.formSelect.alljfNum;
      } else {
        dixianshengyu = 0;
      }
      /** 判断输入金额是否大于总金额 **/
      // if(this.formSelect.realMoney+this.formSelect.realMoney2>this.Lastmoney){
      //     this.$Message.warning('实收金额不能大于商品金额');
      //     return
      // }

      //优惠折扣率  无优惠
      var paymoney = this.formSelect.realMoney*1 + this.formSelect.realMoney2*1;
      var useintegral = 0;

      var youhuitype = 4;
      if (this.formSelect.discount == 1) {
        youhuitype = 4;
        //无优惠
        this.zhekoulv = 100;
        this.formSelect.alljfNum = 0;
        useintegral = 0;

        //还剩多少没支付
        this.formSelect.nomoneys =
          this.formSelect.showMoneys -
          this.formSelect.merge -
          this.formSelect.removeDecimals;
      } else if (this.formSelect.discount == 2) {
        //积分抵现
        youhuitype = 1;
        //还剩多少没支付
        this.formSelect.nomoneys = this.formSelect.nomoneys;

        if (this.formSelect.alljfNum < this.formSelect.showMoneys) {
          useintegral = this.formSelect.customerIntegral;
        } else {
          useintegral =
            this.formSelect.customerIntegral -
            (this.formSelect.customerIntegral / this.jfData.employ -
              this.formSelect.showMoneys) *
              this.jfData.employ;
          dixianshengyu = this.formSelect.customerIntegral - useintegral;
        }
      } else if (this.formSelect.discount == 3) {
        youhuitype = 2;
        //积分打折
        this.formSelect.realMoney = 0;
        this.formSelect.realMoney2 = 0;
        this.formSelect.merge = 0;
        this.formSelect.alljfNum = 0;
        //this.zhekoulv=this.formSelect.showMoneys
        this.formSelect.alljfNum =
          this.formSelect.showMoneys -
          (this.formSelect.showMoneys * this.zhekoulv) / 100;

        this.formSelect.nomoneys = this.formSelect.nomoneys;
        this.zhekoulv = this.zhekoulv;
      } else if (this.formSelect.discount == 4) {
        //会员卡
        /*判断会员卡余额是否充足*/
        if (this.pmoneyTpmoney < this.formSelect.showMoneys) {
          this.$Message.warning("会员卡余额不足，无法开单");
          return;
        }
        this.zhekoulv = 100;
        this.formSelect.alljfNum = 0;
        this.Lastmoney =
          this.formSelect.showMoneys - this.formSelect.removeDecimals;

        paymoney = this.formSelect.merge;
        youhuitype = 3;
        this.formSelect.nomoneys = 0;
      }

      //如果打折和积分抵现都关了
      if (this.jfData.status == "3") {
        this.formSelect.thisBillIntegral = 0;
      }

      this.formSelect.total = 0;
      if (this.ischooseing) {
        this.afterSelection.forEach(item => {
          item.goodsItem.forEach(m => {
            m.lprice = (m.lprice * m.zkv) / 100;
            this.formSelect.total += m.nums;
          });
        });
      } else {
        this.afterSelection.forEach(item => {
          item.goodsItem.forEach(m => {
            m.lprice = (m.pprice * m.zkv) / 100;
            this.formSelect.total += m.nums;
          });
        });
      }
      /** 判断本单积分是否为null**/
      if (!this.formSelect.thisBillIntegral) {
        this.formSelect.thisBillIntegral = 0;
      }

      var data = {
        adminid: this.formSelect.salesperson,
        bankmarket: PortfolioCollection,
        banktype: "",
        cid: this.cid,
        customerid: this.formSelect.user, //客户id
        didscount: this.zhekoulv, //折扣多少
        discountsmoney: this.formSelect.alljfNum, //优惠金额 积分共抵扣****
        dixianshengyu: dixianshengyu,
        money: this.Lastmoney.toFixed(2), // （总金额-抹零）
        nomoney: this.formSelect.nomoneys, //总金额-支付1+支付2+抹零
        paymoney: paymoney.toFixed(2), //支付金额（实付1+实付2）
        removemoney: this.formSelect.removeDecimals, //抹零金额
        sid: this.sid,
        goodslist: this.afterSelection,
        state: 1, //1销售单，2网店订单
        status: 0,
        thistotal: this.formSelect.thisBillIntegral, //本单积分
        total: this.formSelect.total, //合计多少件
        totalmoney: this.formSelect.showMoneys.toFixed(2), //总金额
        useintegral: useintegral, //使用的积分
        way: this.formSelect.remark,
        zkstate: youhuitype //选择优惠方式的状态 1积分抵现 2积分折扣 3会员卡， 4无优惠
      };
      //记忆数据 
      let memoryOption = {customerPfFlag:!this.ischooseing?true:false,//批发客户
            bankid:this.formSelect.discount==4?"":this.formSelect.bank//结算账户,4为选了会员卡
                        };
      localStorage.setItem("memoryOption" + this.sid,JSON.stringify(memoryOption));
      this.loadingOpeningOrder = true;
      //销售开关
      if(this.saleOpen){
        this.saleOpen = false;
      }else{
        this.$Message.warning("请不要频繁点击!");
        return false;
      }
      this.$Api
        .addMarket(data)
        .then(res => {
          if (res.code == 200) {
            this.saleOpen = true;//销售开关
            this.$Message.success("开单成功");
            this.$router.push({
              path: "/salesListDetail",
              query: {
                id: res.data.marketId
              }
            });
          } else {
            this.$Message.warning(res.msg);
          }
          sessionStorage.removeItem("gools");
          this.loadingOpeningOrder = false;
        })
        .catch(err => {
          this.$Message.warning(err.msg);
          this.loadingOpeningOrder = false;
        });
    },
    /** 保存到草稿 **/
    savedraft() {
      if (this.afterSelection.length == 0) {
        return;
      }
      var youhuitype = 4;
      var discount = this.formSelect.discount;
      switch (discount) {
        case 1:
          youhuitype = 4;
          break;
        case 2:
          youhuitype = 1;
          break;
        case 3:
          youhuitype = 2;
          break;
        case 4:
          youhuitype = 3;
          break;
        default:
          youhuitype = 4;
          break;
      }

      var goods = [];
      this.afterSelection.forEach(item => {
        var objitem = {}; //大选项
        objitem.goodsid = item.goodsid;
        var number = 0;
        item.goodsItem.forEach(m => {
          number = number + m.nums;
        });
        objitem.nums = number;
        var arritem = [];
        item.goodsItem.forEach(m => {
          var object = {};
          m.goodsid = item.goodsid;
          m.supperId = m.goodsid+''+m.colorid+''+m.sizeid;
          object.goodsItem = JSON.stringify(m);
          object.goodsid = item.goodsid;
          arritem.push(object);
        });

        objitem.goodsItem = arritem;
        goods.push(objitem);
      });

      var data = {
        cid: this.cid,
        sid: this.sid,
        customerid: this.formSelect.user,
        mlMoney: null == this.formSelect.removeDecimals?0:this.formSelect.removeDecimals,
        remarks: this.formSelect.remark,
        zkstate: youhuitype,
        adminid: this.formSelect.salesperson,
        goods: goods,
        status:0
      };
      this.$Api
        .addManuscript(data)
        .then(res => {
          if (res.code == 200) {
            this.$Message.warning(res.msg);
          } else {
            this.$Message.warning(res.msg);
          }
        })
        .catch(err => {
          this.$Message.warning(err.msg);
        });
    },
    checkNumber(value){ 
			value = value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.');  //仅保留数字和"."
			// value = value.replace(/[^\d.]/g, "");  //仅保留数字和"."
			value = value.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
			value = value.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
			value = value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2');;//限制只能输入两个小数
			if (value.indexOf(".") < 0 && value != "") { //首位是0的话去掉
				value = parseFloat(value);
      }else if(value == null || value == "" || value.indexOf(".") == 0){
        value=0;
      }
      if(document.activeElement.name == "realMoneyName"){
        this.formSelect.realMoney = value;
      }else if(document.activeElement.name == "realMoney2Name"){
        this.formSelect.realMoney2 = value;
      }else if(document.activeElement.name == "removeDecimalName"){
        this.formSelect.removeDecimal = value;
      }
    },
  // //因el-input-number失去焦点才会执行，使用focus和blur来实时改变数据
  // focusOn(){
  //   setInterval(() => {
  //     if (this.focusOnBlur) {
  //       this.cyclicOnData();
  //     }else{
  //       this.focusOnBlur=true;
  //       clearInterval(timer);
  //     }
  //   }, 100);
  // }, 
  // blurOn(){
  //   this.focusOnBlur=false;
  // },
  // //监控处理数据变化
  // cyclicOnData(){
  //   this.cyclicOnDataNum = document.activeElement.value*1;
  //   //实收货款数据
  //   if("realMoneyName" == document.activeElement.name && this.formSelect.realMoney != this.cyclicOnDataNum){
  //     this.formSelect.realMoney = document.activeElement.value;
  //   }
  // },       
  //监听键盘事件
  handleKeyDown(e) {
    // var key = window.event.keyCode ? window.event.keyCode : window.event.which
    if(e.shiftKey && e.keyCode == this.constant.skQ){//shift+q客户
      this.$refs.userKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skZ){//shift+Z销售员
      this.$refs.salespersonKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skW){//shift+W选择商品
      this.$refs.userKey.blur();
      this.commodityModal = true;
      // this.$refs.searchNeirongKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skR){//shift+r总的选择数量
      this.$refs.allKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作      
    }else if(e.shiftKey && e.keyCode == this.constant.skX){//shift+X历史价格
      if(this.isHistoryOpen){
        this.isHistoryOpen=false;
      }else{
        this.isHistoryOpen=true;
      }
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skE && this.commodityModal){//shift+E商标列表查询框获得焦点
      this.$refs.searchNeirongKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk1){//shift+1选择商品1
      this.setDataListFn(this.goodsListL,0);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk2){//shift+2选择商品2
      this.setDataListFn(this.goodsListL,1);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk3){//shift+3选择商品3
      this.setDataListFn(this.goodsListL,2);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk4){//shift+4选择商品4
      this.setDataListFn(this.goodsListL,3);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk5){//shift+5选择商品5
      this.setDataListFn(this.goodsListL,4);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk6){//shift+6选择商品6
      this.setDataListFn(this.goodsListL,5);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk7){//shift+7选择商品7
      this.setDataListFn(this.goodsListL,6);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.sk8){//shift+8选择商品8
      this.setDataListFn(this.goodsListL,7);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skLeft){//shift+Left分页选择上一页
      if(this.page.page != 1){
        this.page.page -= 1;
        this.getGoodsList();
        this.page.current = this.page.page;
        e.preventDefault() //取消浏览器原有的当前快捷键操作
      }
    }else if(e.shiftKey && e.keyCode == this.constant.skRight){//shift+Right分页下一页
      let totalPage = Math.ceil(this.page.total/8);
      if(this.page.page < totalPage){
        this.page.page += 1;
        this.getGoodsList();
        this.page.current = this.page.page;
        e.preventDefault() //取消浏览器原有的当前快捷键操作
      }
    }else if(e.shiftKey && e.keyCode == this.constant.skT){//shift+T抹零金额
      this.$refs.removeDecimalKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skC){//shift+c存草稿
      this.savedraft();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skY){//shift+y结算账户
      this.$refs.bankKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skA){//shift+a实收金额
      this.$refs.realMoneyKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skS){//shift+s未收金额
      this.normerbtn();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skD){//shift+D组合收款
      if(this.isOpenCb){
        this.isOpenCb=false;
      }else{
        this.isOpenCb=true;
      }
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skF){//shift+F结算账户2 组合收款
      this.$refs.bank2Key.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skG){//shift+G实收金额2 组合收款
      this.$refs.realMoney2Key.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skH){//shift+H补款/清零 组合收款
      this.normerbtns();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skJ){//shift+J备注
      this.$refs.remarkKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skV){//shift+v选择优惠方式
      this.$refs.discountKey.focus();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }
    //带ENTER的
    else if(e.shiftKey && e.keyCode == this.constant.skEnter && !this.commodityModal && document.activeElement.name == "removeDecimalName"){//抹零金额确认
      this.moling();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skEnter && this.commodityModal && document.activeElement.name == "searchNeirongName"){//商品列表查询商品
      this.getGoodsList(true);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.keyCode == this.constant.skEnter && this.commodityModal){//商品列表选完确定
      this.addsSelectItem(true);
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }else if(e.shiftKey && e.keyCode == this.constant.skEnter && !this.commodityModal){//出售
      this.openingOrder();
      e.preventDefault() //取消浏览器原有的当前快捷键操作
    }
    //带ctrl的
    else if(e.ctrlKey && e.keyCode == this.constant.skLeft && this.commodityModal){//ctrl+Left选择颜色
      //当前选择的颜色在此商品颜色中的下标可以操作。
      if(this.colorSelectN != 0){
        this.colorSelectN -= 1;
        this.setColorsFn(this.goodsListL,this.selectColorGroup.index,this.colorSelectN);
        e.preventDefault() //取消浏览器原有的当前快捷键操作
      }
    }else if(e.ctrlKey && e.keyCode == this.constant.skRight && this.commodityModal){//ctrl+Right选择颜色
      let num = this.resultItem.colors.length-1;//总的颜色数量
      //当前选择的颜色在此商品颜色中的下标可以操作。
      if(this.colorSelectN<num){
        this.colorSelectN += 1;
        this.setColorsFn(this.goodsListL,this.selectColorGroup.index,this.colorSelectN);
        e.preventDefault() //取消浏览器原有的当前快捷键操作
      }
    }else if(e.ctrlKey && e.keyCode == this.constant.skLeft && !this.commodityModal){//ctrl+Left打开哪个商品
      //打开商品
      if(this.opensTable.length > 0){
        this.opensTable.splice(this.opensTable.length-1,1);
      } 
    }else if(e.ctrlKey && e.keyCode == this.constant.skRight && !this.commodityModal){//ctrl+Right打开哪个商品
      //打开商品
      if(this.afterSelection.length > this.opensTable.length){
        if(!(this.opensTable instanceof Array)){
          let opensTable = this.opensTable;
          this.opensTable = opensTable.split(",");
        }
        this.opensTable.push(this.opensTable.length);
      }
    }
    //带ESC
    else if(e.keyCode == this.constant.skEsc && !this.commodityModal){//esc取消焦点
        document.activeElement.blur();
    }
  },
  showDynamicCustomerList() {
    this.$refs.customerPopover.doShow();
    this.isDynamicListShow = true;
  },
  hideDynamicCustomerList() {
    this.$refs.customerPopover.doClose();
    this.isDynamicListShow = false;
  },
  selectCustomer(customer) {
    this.formSelect.user = customer.id;
    this.selectedUserName = customer.name;
    this.$refs.customerPopover.doClose();
    this.isDynamicListShow = false;
  },
  dynamicCustomerShow() {
    this.isDynamicSearchShow = true;
  },
  dynamicCustomerHide() {
    this.isDynamicSearchShow = false;
  },
  bindCloseDynamicSelectPopover() {
    let _this = this;
    function closeDynamicEvent(e) {
      if (!["/changShop", "/newSale", "/salesList"].includes(_this.$route.path)) {
        document.removeEventListener("click", closeDynamicEvent);
      }
      
      try {
        let parentClass = e.target.parentElement.parentElement.className;
        if (!parentClass.includes("dynamic-customer") && _this.$refs.customerPopover) {
          _this.$refs.customerPopover.doClose();
          _this.isDynamicListShow = false;
        }
      } catch (err) {
        // do nothing
      }
    }
    
    document.addEventListener("click", closeDynamicEvent);
  }
 },
};
</script>

<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.ive-table {
  width: 100%;
  border-collapse: collapse;
  th {
    background: #bfdeff;
    padding: 10px;
  }
  tr td {
    border: 1px solid #ececec;
    padding: 5px;
  }
}
.demo-split {
  height: 600px;
  border: 1px solid #dcdee2;
}
.pageTotal {
  display: flex;
  justify-content: space-between;
}
.zongshu {
  position: relative;
  top: 5px;
  color: rgba(255, 148, 94, 1);
  font-size: 18px;
}
.demo-split-pane {
  padding: 20px;
  position: relative;
  height: 598px;
}
.commodityMsg {
  position: relative;
  padding-left: 105px;
  margin-top: 10px;
  height: 110px;
  .img {
    position: absolute;
    left: 15px;
    top: 0;
  }
  h3 {
    padding-top: 5px;
  }
  .money {
    color: rgba(255, 148, 94, 1);
  }
  .num {
    color: rgba(84, 169, 119, 1);
  }
}
.commodityClolr {
  padding: 20px 0;
  h3 {
    padding: 5px 0 5px 0;
  }
  .tag {
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #e8eaec;
    color: #515a6e;
    border-radius: 3px;

    cursor: pointer;
    margin: 5px 5px 0 0;
  }
}
.commoditymiss {
  h3 {
    margin: 20px 0 10px;
  }
  table {
    text-align: center;
    table-layout: fixed;
    tr {
      th{
        padding-top: 10px;
        div{
          width: 6rem;
          position: relative;
          left: 1rem;
        }        
      }
      td {
        padding-top: 10px;
        div{
          width: 6rem;
          position: relative;
          left: 1rem;
        }
      }
    }
  }
}
.Total {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: center;
  padding: 15px;
  background: #dcdee2;
  color: #ff9900;
}
.formSelect-input {
  width: 11.5rem;
}

.isSelectClass {
  background: #ff9800;
  color: #ffffff !important;
}
.msgOne {
  margin-left: 2rem;
  display: flex;
  strong {
    color: #ff7f7f;
  }
}
.msgAll {
  margin-left: 1rem;
  display: flex;
  strong {
    color: #ff7f7f;
  }
}

.customer-list {
  height: fit-content;
  max-height: 400px;
  overflow: auto;
}

.customer-list li {
  min-height: 34px;
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.customer-list li:hover {
  background-color: #F5F7FA;
}

.no-data-msg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  letter-spacing: 0.08rem;
  text-align: center;
  width: 100%;
}
</style>

<style lang="css">

  .customer-option.el-select-dropdown__item.is-disabled {
    color: #606266;
    cursor: pointer;
    display: list-item !important;
  }

  .load-mote-customer-content {
    background: #2d8cf0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 29px;
    border-radius: 4px;
    color: #fff;
  }

  .customer-list::-webkit-scrollbar {
    width: 5px;
  }

  .customer-list::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  .customer-list::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0,0,0,0.1);
  }

  .dynamic-selector-popover {
    padding: 10px 0;
  }

  .dynamic-customer {
    position: relative;
  }

  .dynamic-custoer-search-arrow {
    position: absolute;
    right: 5px;
    top: 50%;
    color: #C0C4CC;
    transition: 0.5s tranform;
  }

  .dynamic-custoer-search-arrow.down {
    transform: translate(0px, -50%) rotate(180deg);
  }

  .dynamic-custoer-search-arrow.up {
    transform: translate(0px, -50%) rotate(0deg);
  }
  
</style>


<!--
销售单逻辑
1.进入销售单获取商品列表，客户列表，业务员列表，账户列表，积分规则
  1)this.getGoodsList(this.cid, this.sid);
    商品列表初始化默认初始一个商品的单品信息
    this.getCustomerList();
    this.getAdminList();
    this.getBankList();
    this.getIntegralList();
  editallprice editprice修改价格折扣率数量时用到，处理后需要把缓存中的数据替换掉
再次开单逻辑
1.从商品详情中通过缓存把数据代入，进入后页面初始化商品列表，
  getGoodsList//商品列表中初始缓存中的数据getSessionData
  setDataListFn再次开单会初始化这个方法，拿到商品列表第一页的第一个数据当默认展示数据
    把缓存数据和第一页做比对，对上的用缓存数据替换，列表右边的初始数据就是这边处理的
    num这个关键字处理单品数量
  setMoneyall缓存中的数据计算出总的数量金额等，checks这个关键词点击商品时会掉这个方法，checks
    初始0，通过0判断把选择的商品信息加入到缓存中，这样在加减数量时缓存中数据才能正确。
    currentPageData缓存的当前页面所选择的商品，数据不加到这里，选商品后再次开单的商品会没有，
    计算数据的时候也会缺失。
  setColorsFn初始默认的颜色尺寸等信息
  selectDataSingle 设置缓存所选择的项
  isHistoryOpen改变历史价格开关
  changenumber商品总数量监控，需要把缓存数据的this.changeid加到这里不然会加重复
  addsSelectItem处理选后的商品，有历史价格用历史价格替换现有价格，换客户换商品都会重新计算
  addReckonnumber添加商品后计算金额
 -->